import { ReactNode } from 'react';

interface IModalPreviewProps {
  isOpen: boolean;
  onClose: () => void;
  closeAriaLabel: string;
  dialogAriaLabel: string;
  containerClassName?: string;
  dialogClassName?: string;
  children: ReactNode;
}

/** Примитивная модалка-предпросмотр без собственной логики загрузки. */
export default function ModalPreview({
  isOpen,
  onClose,
  closeAriaLabel,
  dialogAriaLabel,
  containerClassName,
  dialogClassName,
  children
}: IModalPreviewProps) {
  const containerClassNames = ['telegram-confirm', isOpen ? 'telegram-confirm--open' : '', containerClassName].filter(Boolean).join(' ');
  const dialogClassNames = ['telegram-confirm__dialog', dialogClassName].filter(Boolean).join(' ');

  return (
    <div className={containerClassNames} aria-hidden={!isOpen}>
      <button
        className="telegram-confirm__backdrop"
        type="button"
        aria-label={closeAriaLabel}
        onClick={onClose}
      />

      <section className={dialogClassNames} role="dialog" aria-modal="true" aria-label={dialogAriaLabel}>
        <div className="telegram-confirm__glow" aria-hidden="true" />
        {children}
      </section>
    </div>
  );
}